
export default {
    name: "popup_chat",
    props: [],
    data(){
        return {
           
        }
    },
    computed: {
        
    },
    mounted(){
    },
    methods: {
        onClickCloseBtn(){
            this.$emit("update:isOpenChatArea", false);
            this.$store.commit("chatapp/resetSelectedRoom");
            this.$store.commit("chatapp/resetMessageList");
            this.$store.commit("chatapp/resetTempRoom");
            this.$store.commit("chatapp/setRoomList", []);
            this.onHandleTriggerAnalytics("close@chat_area");
        },
    },
    watch: {
        
    }
}
